var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"col-2 d-flex align-center justify-center section-header"},[_c('div',{staticClass:"h-divider"}),_c('h1',{staticClass:"ma-8"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"h-divider"})])}
var staticRenderFns = []

export { render, staticRenderFns }